import { TeamsService } from '@teams/infra';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { RemoveTeamMemberPathParams } from '@core-http';

export class RemoveTeamMemberCommandHandler {
  private readonly teamsService: TeamsService = inject(TeamsService);

  remove(teamId: string, memberId: string): Observable<void> {
    const pathParams: RemoveTeamMemberPathParams = { teamId, userId: memberId };

    return this.teamsService.removeMember(pathParams);
  }
}
